import React, {Component} from "react";
import {connect} from "react-redux";
import * as codeEditorActions from "store/actions/codeEditor";
import View from "./View";

class Container extends Component {
  constructor(props) {
    super(props);
    const width = window.innerWidth * (this.props.tutorial.isOpened ? 0.7 : 1);
    const height = window.innerHeight;
    this.state = {
      popupSetting: {
        x: (width - width * 0.625) / 2,
        y: (height - height * 0.725) / 2,
        width: width * 0.625,
        height: height * 0.725,
      },
      isClickCodeDelete: false,
    };
  }

  onChangePopupSetting = changeSetting => {
    this.setState({popupSetting: {...this.state.popupSetting, changeSetting}});
  };

  onClickCloseBtn = () => {
    this.props.setCodeEditor(false);
  };

  onClickCodeDelete = bool => {
    this.setState({isClickCodeDelete: bool});
  };

  render() {
    const {popupSetting, isClickCodeDelete} = this.state;
    const {onChangePopupSetting, onClickCloseBtn, onClickCodeDelete} = this;

    return (
      <View
        popupSetting={popupSetting}
        isClickCodeDelete={isClickCodeDelete}
        onChangePopupSetting={onChangePopupSetting}
        onClickCloseBtn={onClickCloseBtn}
        onClickCodeDelete={onClickCodeDelete}
      />
    );
  }
}

export default connect(
  state => ({
    tutorial: state.tutorial,
  }),
  {
    setCodeEditor: codeEditorActions.setCodeEditor,
  },
)(Container);
